// import external modules
import { reducer as toastrReducer } from 'react-redux-toastr'

import { combineReducers } from 'redux'

// import internal(own) modules
import analyticsReducer from './analytics'
import calenderReducer from './calenderReducer'
// import chatReducer from "./chatReducer";
import chatReducer from './chat'
import contactsReducer from './contacts'
import customizer from './customizer'
import emailReducer from './email'
import surveyReportReducer from './reports/surveyReportReducer'
import todoReducer from './todo'
import user from './user'

const rootReducer = combineReducers({
	calender: calenderReducer,
	emailApp: emailReducer,
	contactApp: contactsReducer,
	todoApp: todoReducer,
	toastr: toastrReducer, // <- Mounted at toastr.
	chatApp: chatReducer,
	customizer,
	user,
	analytics: analyticsReducer,
	survey_reports: surveyReportReducer, // Add the new reducer here
})

export default rootReducer
